import RESTService from './RESTService';
import RoutingService from './RoutingService';
import _ from 'lodash';
let instance = null;
const RS = new RoutingService();
const connect = new RESTService();

export default class AppConfigService {
	constructor() {
		if (instance) {
			return instance;
		}
		instance = this;
	}

	updateConfig(action) {
		connect.getTenantEnvironments(RS.getCurrentTenant()).then(res => {
			let idx = _.findIndex(res.data, function(env) {
				return env.name === RS.getCurrentEnvironment();
			});
			let e = res.data[idx];
			if (e && e.installedApps) {
				let apps = Object.keys(e.installedApps);
				_.forEach(apps, app => {
					connect
						.getAppConfig({
							name: app
						})
						.then(response => {
							action(response.data);
						})
						.catch(err => {
							console.log(err);
							RS.smartError(err);
						});
				});
			}
		});
	}

	populateEndpoint(endpoint) {
		this.updateConfig(config => {
			let current = config.endpoints;
			if (!current) {
				current = {};
			}
			let epTpl = {
				templateUrl: `/api/v1/global/[environment]/${endpoint.name}`,
				type: endpoint.type,
				templates: endpoint.templates
			};
			current[endpoint.name] = epTpl;
			connect.updateAppConfigSegment('endpoints', current, config.name).catch(err => {
				console.log(err);
				RS.smartError(err);
			});
		});
	}

	removeEndpoint(name) {
		this.updateConfig(config => {
			let current = config.endpoints;
			if (!current) {
				current = {};
			}
			if (current[name]) {
				delete current[name];
				connect.updateAppConfigSegment('endpoints', current, config.name).catch(err => {
					console.log(err);
					RS.smartError(err);
				});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/AppConfigService.js